import { format } from 'date-fns';
import { Order } from 'types/order';
import { convertToHUF } from 'utils/helpers';

interface IProps {
  orderData: Order;
}

const szazalek = (ertek: number, szaz: number): number =>
  Math.round((ertek * (szaz || 0)) / 100);

const OrderSummary = ({ orderData }: IProps) => (
  <section className="pb-4 mb-4">
    <div className="w-full mb-8 border-b-darkBlue-5 border" />
    <h3 className="text-xl font-semibold mb-4">Összesített ár</h3>
    <div className="flex flex-wrap justify-between">
      <div className="w-full flex justify-between text-darkBlue-20 font-semibold">
        <div>Nettó ár: </div>
        <div>{convertToHUF(orderData.total.net)}</div>
      </div>
      <div className="w-full flex justify-between text-darkBlue-20 font-semibold">
        <div>ÁFA: </div>
        <div>{convertToHUF(orderData.total.vat)}</div>
      </div>
      <div className="w-full flex justify-between text-darkBlue-20 font-semibold">
        <div>Kedvezmény mértéke: </div>
        <div>{convertToHUF(szazalek(orderData.total.gross, orderData.cuponRate))}</div>
      </div>
      <div className="w-full my-4 border-b-darkBlue-5 border" />
      <div className="w-full flex justify-between text-darkBlue text-2xl font-semibold">
        <div>Összesen: </div>
        <div>
          {convertToHUF(
            orderData.total.gross - szazalek(orderData.total.gross, orderData.cuponRate)
          )}
        </div>
      </div>
      {orderData.recurring ? (
        <>
          <div>
            <div className="text-darkBlue font-semibold mt-4 mb-2">
              Kártyaregisztráció adatai:
            </div>
          </div>
          <div className="w-full flex justify-between text-darkBlue-60 font-semibold">
            <div>Lejárat ideje</div>
            <div>
              {format(new Date(orderData.recurring.recurringUntil), 'yyyy. MM. dd.')}
            </div>
          </div>
          <div className="w-full flex justify-between text-darkBlue-60 font-semibold">
            <div>Fizetési tranzakciók száma: </div>
            <div>{orderData.recurring.recurringTimes}</div>
          </div>
          <div className="w-full flex justify-between text-darkBlue-60 font-semibold">
            <div>Maximális értékhatár</div>
            <div>{convertToHUF(orderData.recurring.recurringMaxAmount)}</div>
          </div>
        </>
      ) : null}
    </div>
  </section>
);

export default OrderSummary;
